class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.desktopHoverQuery = window.matchMedia('(min-width: 990px)');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.hoverCloseTimer = null;

    this.summary.addEventListener(
      'click',
      (event) => {
        if (!this.desktopHoverQuery.matches) return;

        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    this.addEventListener('mouseenter', () => {
      if (!this.desktopHoverQuery.matches) return;

      window.clearTimeout(this.hoverCloseTimer);
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', 'true');
      this.loadAutomaticVendorMenu();
    });

    this.addEventListener('mouseleave', () => {
      if (!this.desktopHoverQuery.matches) return;

      this.hoverCloseTimer = window.setTimeout(() => this.close(), 220);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  async loadAutomaticVendorMenu() {
    const vendorList = this.querySelector('[data-auto-vendor-menu]');
    loadAutomaticVendorList(vendorList);
  }
}

customElements.define('header-menu', HeaderMenu);

async function loadAutomaticVendorList(vendorList) {
  if (!vendorList || vendorList.dataset.loaded === 'true' || vendorList.dataset.loading === 'true') return;

  const collectionUrl = vendorList.dataset.collectionUrl;
  if (!collectionUrl || collectionUrl === '#') return;

  vendorList.dataset.loading = 'true';

  try {
    const response = await fetch(collectionUrl, { credentials: 'same-origin' });
    if (!response.ok) return;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const vendorInputs = Array.from(doc.querySelectorAll('input[name="filter.p.vendor"]'));
    const seenVendors = new Set();
    const vendorItems = [];
    const baseUrl = collectionUrl.split('?')[0];

    vendorInputs.forEach((input) => {
      const vendorValue = input.value ? input.value.trim() : '';
      const label = input.closest('label');
      const labelNode = label ? label.querySelector('.facet-checkbox__text-label') : null;
      const labelText = labelNode ? labelNode.textContent.trim() : vendorValue;

      if (!vendorValue || !labelText) return;

      const vendorKey = vendorValue.toLowerCase();
      if (seenVendors.has(vendorKey)) return;

      seenVendors.add(vendorKey);
      vendorItems.push({ label: labelText, value: vendorValue });
    });

    if (!vendorItems.length) return;

    vendorList.innerHTML = vendorItems
      .map(
        (vendor) => `
          <li>
            <a href="${baseUrl}?filter.p.vendor=${encodeURIComponent(vendor.value)}" class="mega-menu__link mega-menu__vendor-link link">
              ${escapeVendorMenuHTML(vendor.label)}
            </a>
          </li>
        `
      )
      .join('');
    vendorList.dataset.loaded = 'true';
  } catch (error) {
    console.warn('Unable to load automatic vendor menu', error);
  } finally {
    vendorList.dataset.loading = 'false';
  }
}

function escapeVendorMenuHTML(value) {
  return value.replace(/[&<>"']/g, (character) => {
    const entities = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    };

    return entities[character];
  });
}

function loadAutomaticVendorMenus() {
  document.querySelectorAll('[data-auto-vendor-menu]').forEach((vendorList) => {
    loadAutomaticVendorList(vendorList);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', loadAutomaticVendorMenus);
} else {
  loadAutomaticVendorMenus();
}
